import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { Props } from "./types";
import styles from "./styles.scss";

function PlanzoneForm({ formData, error, editForm }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.form}>
      <div className={styles.group}>
        <h3 className={styles.label}>
          {t("accountCreationConfirmation.planzoneNameTitle")}
        </h3>
        <input
          value={formData.planzone.name}
          placeholder={t("accountCreationConfirmation.planzoneNamePlaceholder")}
          className={classNames(styles.input, {
            [styles.invalidInput]: error.isPlanzoneInvalid.isNameInvalid,
          })}
          onChange={({ target }) =>
            editForm({
              ...formData,
              planzone: {
                ...formData.planzone,
                name: target.value,
              },
            })
          }
        />
      </div>
      <div className={styles.group}>
        <h3 className={styles.label}>
          {t("accountCreationConfirmation.planzoneDomainTitle")}
        </h3>
        <input
          value={formData.planzone.domain}
          placeholder={t(
            "accountCreationConfirmation.planzoneDomainPlaceholder",
          )}
          className={classNames(styles.input, {
            [styles.invalidInput]: error.isPlanzoneInvalid.isDomainInvalid,
          })}
          onChange={({ target }) =>
            editForm({
              ...formData,
              planzone: {
                ...formData.planzone,
                domain: target.value,
              },
            })
          }
        />
      </div>
    </div>
  );
}

export { PlanzoneForm };
